<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "pecipeStatistics",
  data() {
    return {
      msg: ""
    }
  },
  component: {
    //someComponent
  },
  methods: {
    //
  },
  mounted() {
    //
  }
}
</script>

<style lang="scss" scoped>
.index {

}
</style>